import React, { useState, useEffect, useRef } from "react";

import StudentTemplate from "../../component/StudentTemplate";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import Api from "../../component/Api";
import Swal from "sweetalert2";

export default function CondonationPage() {
  const [activecoTab, setActivecoTab] = useState(null);
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [eventStatus, setEventStatus] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [otherReasonText, setOtherReasonText] = useState("");
  const [remarkText, setRemarkText] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [applicationFee, setApplicationFee] = useState(null);
  const [fileBlobMap, setFileBlobMap] = useState(new Map());
  const [eligibleForApply, setEligibleForApply] = useState(false);
  const [eligibleForEdit, setEligibleForEdit] = useState(false);
  const [certificateDownload, setEligibleForCertificate] = useState(false);
  const [accountid, setAccountid] = useState(null);

  const [transactionStatus, setTransactionStatus] = useState(null);
  const [paidAmount, setPaidAmount] = useState(0);
  const [originalReason, setOriginalReason] = useState(null);
  const [originalOtherReason, setOriginalOtherReason] = useState("");
  const [originalRemarkText, setOriginalRemarkText] = useState("");

  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [tempFiles, setTempFiles] = useState([]);

  // New state for view application modal
  const [showViewModal, setShowViewModal] = useState(false);
  const [applicationDetails, setApplicationDetails] = useState(null);
  const [canProceedToPayment, setCanProceedToPayment] = useState(false);

  // Document types with predefined categories
  const reasonOptions = [
    { id: 1, label: "Medical" },
    { id: 2, label: "Others" },
  ];
  const documentTypeOptions = ["Medical Certificate", "Others"];
  const documentTypeOptionsFormatted = documentTypeOptions.map((type) => ({
    value: type,
    label: type,
  }));

  const reasonOptionsFormatted = reasonOptions.map((reason) => ({
    value: reason.id,
    label: reason.label,
  }));

  const defaultDocumentTypes = [
    { id: 1, type: "Medical Certificate", files: [] },
    { id: 2, type: "Others", files: [] },
  ];

  const [documentTypes, setDocumentTypes] = useState(defaultDocumentTypes);

  const fileInputRef = useRef(null);

  const handleFormChange = () => {
    if (canProceedToPayment) {
      setCanProceedToPayment(false);
    }
  };
  const populateFormFromAPI = (response) => {
    try {
      // 1. Populate Reason and Remarks
      if (response.reason_remarks && response.reason_remarks.length > 0) {
        const reasonData = response.reason_remarks[0];

        setSelectedReason(reasonData.student_reason);

        if (reasonData.student_reason === 2 && reasonData.other_reason) {
          setOtherReasonText(reasonData.other_reason);
        }

        if (reasonData.student_remarks) {
          setRemarkText(reasonData.student_remarks);
        }
      }

      // 2. Populate Documents
      if (response.documents && response.documents.length > 0) {
        const populatedDocuments = [];

        // Group documents by doc_type
        const docsByType = {};

        response.documents.forEach((doc) => {
          const docType = doc.docu_name;
          if (!docsByType[docType]) {
            docsByType[docType] = {
              id: doc.doc_type,
              type: docType,
              files: [],
              existingFiles: [],
            };
          }

          docsByType[docType].existingFiles.push({
            doc_id: doc.doc_id,
            name: doc.name,
            url: doc.url,
          });
        });

        // Convert to array
        Object.values(docsByType).forEach((docGroup) => {
          populatedDocuments.push(docGroup);
        });

        setDocumentTypes(populatedDocuments);
      }

      // 3. DON'T enable payment button automatically - let user save changes first
      setCanProceedToPayment(false);
    } catch (error) {
      toast.error("Failed to load saved data");
    }
  };

  // Helper to remove newly added files
  const removeNewFile = (docId, fileIndex) => {
    setDocumentTypes((prevDocs) =>
      prevDocs.map((doc) => {
        if (doc.id === docId) {
          const updatedFiles = doc.files.filter((_, idx) => idx !== fileIndex);
          return { ...doc, files: updatedFiles };
        }
        return doc;
      })
    );
    setCanProceedToPayment(false); // Reset to require save
    toast.info("File removed");
  };
  const handleCoTabClick = (semNum) => {
    setActivecoTab(semNum);
  };
  useEffect(() => {
    const { http } = Api();

    const fetchFee = async () => {
      try {
        const response = await http.get("/Student/getCondonationFee");
        const fee = response.data.condonation_fee;
        const semester = response.data.current_semester;

        setApplicationFee(fee);
        setActivecoTab(semester); // set this AFTER we know it
      } catch (error) {
        console.error("Error fetching condonation fee:", error);
      }
    };

    fetchFee();
  }, []);

  useEffect(() => {
    if (!activecoTab) return;

    const { http } = Api();

    const fetchCourses = async () => {
      try {
        setLoading(true);

        const response = await http.get("/Student/getCondonationCourses", {
          params: { semester: activecoTab },
        });

        setEligibleForApply(response.data.eligble_for_apply);
        setEligibleForEdit(response.data.eligble_for_edit);
        setTransactionStatus(
          response.data.reason_remarks?.[0]?.condonation_txn_status || null
        );

        const event = response.data.event_status;
        setEventStatus(event);

        const data = response.data.courses || [];
        const filteredCourses = data.filter(
          (course) => course.semesterid === activecoTab
        );
        setCourses(filteredCourses);
        setAccountid(data[0].accountid);

        const reasonRemark = response.data.reason_remarks || [];
        setEligibleForCertificate(
          reasonRemark?.[0]?.section_status === "vc_approved"
        );
        

        const successfulPayment = reasonRemark.find(
          (r) => r.payment_status?.toLowerCase() === "success"
        );

        const paidAmount = successfulPayment
          ? successfulPayment.paid_amount
          : 0;
        setPaidAmount(paidAmount);

        const feeResponse = await http.get("/Student/getCondonationFee");
        const newfee = feeResponse.data.condonation_fee;
        setApplicationFee(paidAmount > 0 ? paidAmount : newfee);
        // Store application details
        setApplicationDetails({
          documents: response.data.documents || [],
          reasonRemarks: response.data.reason_remarks || [],
          reasonType: response.data.reasonType || [],
          documentType: response.data.documentType || [],
          coursesStatus: response.data.coursesStatus || null,
        });

        // 🔥 POPULATE FORM IF DATA EXISTS IN RESPONSE
        const hasSavedData =
          response.data.reason_remarks?.length > 0 ||
          response.data.documents?.length > 0;

        if (hasSavedData) {
          populateFormFromAPI(response.data);
        } else {
          // Reset to defaults for fresh application
          setDocumentTypes(defaultDocumentTypes);
          setSelectedReason("");
          setOtherReasonText("");
          setRemarkText("");
          setCanProceedToPayment(false);
        }
      } catch (error) {
        // toast.error("Error fetching courses!");
        setCourses([]);
        setEventStatus(null);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [activecoTab]);

  const removeExistingFile = async (docTypeId, docId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This document will be permanently deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return; // User canceled

    // Check if this is a temporary file (not yet in DB)
    const isTemp = String(docId).startsWith("temp_");

    if (isTemp) {
      // Handle temporary file removal (client-side only)
      setDocumentTypes((prevDocs) =>
        prevDocs.map((doc) =>
          doc.id === docTypeId
            ? {
                ...doc,
                existingFiles: doc.existingFiles.filter(
                  (file) => String(file.doc_id) !== String(docId)
                ),
              }
            : doc
        )
      );

      // Clean up blob URL
      if (fileBlobMap.has(docId)) {
        URL.revokeObjectURL(fileBlobMap.get(docId));
        setFileBlobMap((prev) => {
          const newMap = new Map(prev);
          newMap.delete(docId);
          return newMap;
        });
      }

      setCanProceedToPayment(false);

      Swal.fire("Deleted!", "Document removed successfully", "success");
      return;
    }

    // Handle actual DB file removal
    let previousDocs;
    setDocumentTypes((prevDocs) => {
      previousDocs = prevDocs;
      return prevDocs.map((doc) =>
        doc.id === docTypeId
          ? {
              ...doc,
              existingFiles: doc.existingFiles.filter(
                (file) => String(file.doc_id) !== String(docId)
              ),
            }
          : doc
      );
    });

    setCanProceedToPayment(false);

    try {
      const { http } = Api();
      const response = await http.post("/Student/deleteCondonationPDF", {
        doc_id: docId,
      });

      if (response.data?.success) {
        Swal.fire(
          "Deleted!",
          response.data.message || "Document deleted successfully",
          "success"
        );
      } else {
        setDocumentTypes(previousDocs); // rollback
        Swal.fire(
          "Error",
          response.data?.message || "Failed to delete document.",
          "error"
        );
      }
    } catch (error) {
      setDocumentTypes(previousDocs); // rollback
      Swal.fire(
        "Error",
        error.response?.data?.message ||
          "An error occurred while deleting the document",
        "error"
      );
    }
  };
  const handleCertificateDownload = async () => {
    try {
      const { http } = Api();

      const response = await http.get("College/condonationCertificatePdf", {
        params: {
          accountid: accountid,
          semester: activecoTab,
        },
        responseType: "blob",
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "CondonationCertificate.pdf";
      a.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Unable to download certificate");
    }
  };

  const openModal = () => {
    setShowModal(true);

    // ✅ Store original values only when editing
    if (eligibleForEdit) {
      setOriginalReason(selectedReason);
      setOriginalOtherReason(otherReasonText);
      setOriginalRemarkText(remarkText);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setPreviewFile(null);
  };

  const openViewModal = () => {
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setPreviewFile(null);
  };

  const handlePreview = async (file) => {
    try {
      let fileURL = "";
      let fileName = "";

      // Priority 1: Check for temporary blob URL (newly saved files)
      if (file.tempBlobURL && file.tempBlobURL.startsWith("blob:")) {
        fileURL = file.tempBlobURL;
        fileName = file.name || "Document";
        setPreviewFile({ name: fileName, url: fileURL });
        return;
      }

      // Priority 2: Check if doc_id is in fileBlobMap (temp files)
      if (file.doc_id && fileBlobMap.has(file.doc_id)) {
        fileURL = fileBlobMap.get(file.doc_id);
        fileName = file.name || "Document";
        setPreviewFile({ name: fileName, url: fileURL });
        return;
      }

      // Priority 3: Handle temp blob files and newly uploaded files
      if (
        file.isTemp ||
        (file.url && file.url.startsWith("blob:")) ||
        file instanceof File
      ) {
        if (file instanceof File) {
          fileURL = URL.createObjectURL(file);
        } else {
          fileURL = file.url;
        }
        fileName = file.name || "Document";
        setPreviewFile({ name: fileName, url: fileURL });
        return;
      }

      const { http } = Api();
      const apiBaseUrl = http.defaults.baseURL || window.location.origin;

      // Priority 4: Use GET API with doc_id for existing files in DB (non-temp)
      if (file.doc_id && !String(file.doc_id).startsWith("temp_")) {
        try {
          const response = await http.get(
            `/Student/viewCondonationPDF?doc_id=${file.doc_id}`,
            {
              responseType: "blob",
              headers: {
                Accept: "application/pdf",
              },
            }
          );

          if (response.data && response.data.type === "application/pdf") {
            const blob = new Blob([response.data], { type: "application/pdf" });
            fileURL = URL.createObjectURL(blob);
            fileName = file.name || "Document";

            setPreviewFile({ name: fileName, url: fileURL });
            return;
          } else {
            throw new Error("Invalid PDF response");
          }
        } catch (apiError) {
          console.warn(
            "API fetch failed, falling back to URL method:",
            apiError
          );
        }
      }

      // Priority 5: Fallback to URL only if doc_id method fails or unavailable
      if (typeof file === "object" && file.url) {
        fileURL = file.url.startsWith("http")
          ? file.url
          : `${apiBaseUrl.replace("/api/", "/")}${
              file.url.startsWith("/") ? file.url : "/" + file.url
            }`;
        fileName = file.name || "Document";
      } else if (typeof file === "string") {
        fileURL = file.startsWith("http")
          ? file
          : `${apiBaseUrl.replace("/api/", "/")}${
              file.startsWith("/") ? file : "/" + file
            }`;
        fileName = "Document";
      } else {
        throw new Error("Invalid file format");
      }

      setPreviewFile({ name: fileName, url: fileURL });
    } catch (error) {
      toast.error("Unable to preview this file");
    }
  };

  const handleNewFilePreview = (file) => {
    // For mobile devices with newly uploaded files, open in new tab
    if (window.innerWidth < 768 && (file instanceof File || !file.url)) {
      try {
        const fileURL =
          file instanceof File ? URL.createObjectURL(file) : file.url;
        window.open(fileURL, "_blank");
        return true; // Indicates we handled it separately
      } catch (error) {
        toast.error("Unable to preview this file");
        return true;
      }
    }

    // For desktop or other cases, use the original handler
    return false;
  };
  const closePreview = () => {
    if (previewFile?.url && previewFile.url.startsWith("blob:")) {
      URL.revokeObjectURL(previewFile.url);
    }
    setPreviewFile(null);
  };

  const handleSaveDetails = async () => {
    if (isUploading) return;

    const hasNewFiles = documentTypes.some(
      (type) => type.files && type.files.length > 0
    );
    const hasExistingFiles = documentTypes.some(
      (type) => type.existingFiles && type.existingFiles.length > 0
    );

    if (!hasNewFiles && !hasExistingFiles) {
      toast.error("Please select at least one document to upload!");
      return;
    }

    if (!selectedReason) {
      toast.error("Please select a reason!");
      return;
    }

    if (selectedReason === 2 && !otherReasonText.trim()) {
      toast.error("Please specify the reason!");
      return;
    }

    try {
      // ⚠️ Confirm ONLY for eligibleForEdit
      if (eligibleForEdit) {
        // ✅ Check if any changes were made (only in edit mode)
        const hasChanges =
          hasNewFiles ||
          selectedReason !== originalReason ||
          otherReasonText !== originalOtherReason ||
          remarkText !== originalRemarkText;

        if (!hasChanges) {
          toast.warning("Please make at least one change before saving!");
          return;
        }

        const { isConfirmed } = await Swal.fire({
          title: "Are you sure?",
          text: "This action will update your application. You won't get a second chance!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, Save it!",
          cancelButtonText: "Cancel",
        });

        if (!isConfirmed) return;
      }

      setIsUploading(true);
      const { http } = Api();
      let uploadSuccess = false;

      // =====================
      // Handle eligible for edit
      // =====================
      if (eligibleForEdit) {
        // Save new files if any
        if (hasNewFiles) {
          for (const docType of documentTypes) {
            if (docType.files && docType.files.length > 0) {
              for (const file of docType.files) {
                const formData = new FormData();
                formData.append("semester", activecoTab);
                formData.append("doc_type", docType.id);
                formData.append("file", file);
                formData.append("student_reason", selectedReason);
                formData.append("other_reason", otherReasonText || "");
                formData.append("student_remarks", remarkText || "");
                formData.append("application_fee", applicationFee);

                const res = await http.post(
                  "/Student/saveCondonationDocument",
                  formData,
                  { headers: { "Content-Type": "multipart/form-data" } }
                );

                if (res.data.update_status === 1) {
                  uploadSuccess = true;

                  // Update frontend dynamically
                  setDocumentTypes((prevDocs) =>
                    prevDocs.map((doc) => {
                      if (doc.id === docType.id) {
                        const newFile = {
                          doc_id: `temp_${Date.now()}`,
                          name: file.name,
                          url: URL.createObjectURL(file),
                          isTemp: true,
                        };
                        return {
                          ...doc,
                          existingFiles: [
                            ...(doc.existingFiles || []),
                            newFile,
                          ],
                          files: [],
                        };
                      }
                      return doc;
                    })
                  );
                } else {
                  toast.error("Failed to save file.");
                }
              }
            }
          }
        }

        // Metadata-only update
        if (!hasNewFiles && hasExistingFiles) {
          const payload = {
            semester: activecoTab,
            student_reason: selectedReason,
            other_reason: otherReasonText || "",
            student_remarks: remarkText || "",
            application_fee: applicationFee,
          };

          const res = await http.post(
            "/Student/updateCondonationDocument",
            payload
          );
          if (res.data.update_status === 1) uploadSuccess = true;
        }

        if (uploadSuccess) {
          // ✅ Close modal first
          setShowModal(false);

          await Swal.fire({
            title: "Success!",
            text: "Application updated successfully.",
            icon: "success",
          });

          // ✅ Manually update states to reflect changes immediately
          setEligibleForEdit(false);
          setTransactionStatus(2); // Mark as completed/paid
          window.location.reload();
        } else {
          toast.error("Failed to update application.");
        }

        return; // exit early for edit
      }

      // =====================
      // Handle new application save
      // =====================
      if (hasNewFiles) {
        for (const docType of documentTypes) {
          if (docType.files && docType.files.length > 0) {
            for (const file of docType.files) {
              const formData = new FormData();
              formData.append("semester", activecoTab);
              formData.append("doc_type", docType.id);
              formData.append("file", file);
              formData.append("student_reason", selectedReason);
              formData.append("other_reason", otherReasonText || "");
              formData.append("student_remarks", remarkText || "");
              formData.append("application_fee", applicationFee);

              const res = await http.post(
                "/Student/saveCondonationDocument",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
              );

              if (res.data.update_status === 1) uploadSuccess = true;
            }
          }
        }
      }

      // Metadata-only update
      if (!hasNewFiles && hasExistingFiles) {
        const payload = {
          semester: activecoTab,
          student_reason: selectedReason,
          other_reason: otherReasonText || "",
          student_remarks: remarkText || "",
          application_fee: applicationFee,
        };

        const res = await http.post(
          "/Student/updateCondonationDocument",
          payload
        );
        if (res.data.update_status === 1) uploadSuccess = true;
      }

      if (uploadSuccess) {
        // ✅ Simple toast notification for normal save
        toast.success(
          "Details saved successfully. You can proceed to payment."
        );

        setCanProceedToPayment(true);

        // Move newly uploaded files to existingFiles
        setDocumentTypes((prevDocs) =>
          prevDocs.map((doc) => {
            if (doc.files && doc.files.length > 0) {
              const newlySavedFiles = doc.files.map((file, idx) => ({
                doc_id: `temp_${Date.now()}_${idx}`,
                name: file.name,
                url: URL.createObjectURL(file),
                tempBlobURL: URL.createObjectURL(file),
                isTemp: true,
              }));
              return {
                ...doc,
                existingFiles: [
                  ...(doc.existingFiles || []),
                  ...newlySavedFiles,
                ],
                files: [],
              };
            }
            return doc;
          })
        );

        if (fileInputRef.current) fileInputRef.current.value = "";
        setTempFiles([]);

        // ✅ Keep modal OPEN so user can see "Proceed to Payment" button
        // Modal will close automatically after payment or user can close it manually
      } else {
        toast.error("Failed to save details.");
      }
    } catch (error) {
      toast.error("Failed to save details!");
    } finally {
      setIsUploading(false);
    }
  };

  const handleProceedToPayment = async () => {
    try {
      // Show SweetAlert2 confirmation modal
      const result = await Swal.fire({
        title: "Confirm Payment",
        html: `<p class="fw-bold">You are about to pay: <strong>₹${applicationFee}</strong></p>
             <p>Do you want to proceed?</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Pay Now",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!result.isConfirmed) return; // User cancelled

      // Proceed with payment API call
      const { http } = Api();
      const res = await http.post("/Student/condonationPaymentByStudent", {
        semester: activecoTab,
        condonation_amount: applicationFee,
      });

      if (res.data?.url && res.data?.reqParam) {
        const { url, reqParam } = res.data;

        const form = document.createElement("form");
        form.method = "POST";
        form.action = url;
        form.id = "frmpaymentaction";

        const input = document.createElement("input");
        input.type = "hidden";
        input.name = "epay_req_params";
        input.value = reqParam;

        form.appendChild(input);
        document.body.appendChild(form);

        form.submit();
      } else {
        toast.error("Payment initiation failed!");
      }
    } catch (error) {
      toast.error("Failed to proceed with payment!");
    }
  };

  useEffect(() => {
    return () => {
      // Clean up all blob URLs when component unmounts
      fileBlobMap.forEach((blobURL) => {
        URL.revokeObjectURL(blobURL);
      });
    };
  }, []);

  const generateCondonationPdf = async () => {
    if (!activecoTab) {
      toast.error("Select a semester first!");
      return;
    }

    try {
      setLoading(true);

      const { http } = Api();

      const response = await http.get("/Student/generateCondonationPdf", {
        params: { semester: activecoTab }, // query param for GET
        responseType: "blob", // important for PDF
        headers: { Accept: "application/pdf" },
      });

      // Create URL for blob
      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      // Open PDF in a new tab
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      link.remove();

      toast.success("PDF generated successfully!");
    } catch (error) {
      toast.error("Failed to generate PDF!");
    } finally {
      setLoading(false);
    }
  };

  // Check if any course has payment success status
  return (
    <StudentTemplate>
      <ToastContainer />

      <div className="col-12 mb-0 order-5 order-md-5">
        <div className="card tranaction-card">
          <div className="card-header card-no-border">
            <div className="d-flex justify-content-center align-items-center mb-3 mb-md-4">
              <h3 className="card-title text-center mb-4 font-weight-bold text-black mobile">
                Semester wise Courses - Eligible for Condonation
              </h3>
            </div>

            {/* Semester Tabs Wrapper */}
            <div className="semester-tabs-wrapper mb-3 mb-md-4">
              {/* Mobile dropdown */}
              <select
                className="form-select d-md-none mb-3"
                value={activecoTab}
                onChange={(e) => handleCoTabClick(parseInt(e.target.value))}
              >
                {[...Array(8)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    Semester {i + 1}
                  </option>
                ))}
              </select>

              {/* Desktop horizontal buttons */}
              <div className="st-dash-sem-tab d-none d-md-block">
                <div className="semester-tabs">
                  {[1, 2, 3, 4, 5, 6, 7, 8].map((semNum) => (
                    <button
                      key={semNum}
                      className={`semester-tab ${
                        activecoTab === semNum ? "active" : ""
                      }`}
                      onClick={() => handleCoTabClick(semNum)}
                    >
                      Sem {semNum}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="card-body p-2 p-md-3">
            {eventStatus === "active" ? (
              <div>
                {/* Mobile Card View */}
                <div className="d-md-none">
                  {loading ? (
                    <div className="text-center py-4">
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : courses.length > 0 ? (
                    <div className="row g-2">
                      {courses.map((course, index) => (
                        <div key={course.course_id} className="col-12">
                          <div className="card border h-100">
                            <div className="card-body p-3">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <span className="badge bg-primary rounded-pill">
                                  {index + 1}
                                </span>
                                <span className="badge bg-secondary">
                                  {course.course_code}
                                </span>
                              </div>

                              <h6
                                className="card-title text-truncate mb-2"
                                title={course.course_name}
                              >
                                {course.course_name}
                              </h6>
                              <div classname="flex align-items-center">
                                <small className="text-muted me-2">
                                  Condonation Hours:
                                </small>
                                {course.condonation_time}
                              </div>

                              <div className="mb-2 d-flex align-items-center">
                                <small className="text-muted me-2">
                                  Status:
                                </small>
                                <span
                                  className={`fw-semibold ${
                                    transactionStatus === 2 &&
                                    eligibleForEdit === 0
                                      ? "text-success"
                                      : "text-primary"
                                  }`}
                                >
                                  {course.status_message}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <p className="text-muted mb-0">No courses found.</p>
                    </div>
                  )}
                </div>

                {/* Desktop Table View */}
                <div className="table-responsive d-none d-md-block">
                  <table className="table st-table-hover align-middle table-bordered">
                    <thead className="table-dark">
                      <tr>
                        <th>Sl No.</th>
                        <th>Course Code</th>
                        <th>Course Name</th>
                        <th>Condonation Hours</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            <div className="spinner-border" role="status">
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          </td>
                        </tr>
                      ) : courses.length > 0 ? (
                        courses.map((course, index) => (
                          <tr key={course.course_id}>
                            <td>{index + 1}</td>
                            <td>{course.course_code}</td>
                            <td>{course.course_name}</td>
                            <td>{course.condonation_time}</td>
                            <td>
                              <span
                                className={`badge ${
                                  transactionStatus === 2 &&
                                  eligibleForEdit === 0
                                    ? "bg-success"
                                    : "bg-primary"
                                }`}
                              >
                                {course.status_message}
                              </span>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No courses found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {/* Apply/View Button */}
                {courses.length > 0 && (
                  <div className="d-flex justify-content-center justify-content-md-end mt-3 mt-md-4">
                    {eligibleForEdit ? (
                      // ✏️ Edit Application
                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm w-100 w-sm-auto"
                        style={{ maxWidth: "200px" }}
                        onClick={openModal}
                      >
                        Edit Application
                      </button>
                    ) : transactionStatus === 2 ? (
                      // 👁 View + 📄 Certificate
                      <div className="d-flex gap-2 align-items-center">
                        <button
                          type="button"
                          className="btn btn-primary btn-sm w-100 w-sm-auto"
                          style={{ maxWidth: "200px" }}
                          onClick={openViewModal}
                        >
                          View Application
                        </button>

                        {certificateDownload && (
                          <button
                            type="button"
                            className="btn btn-success btn-sm w-100 w-sm-auto"
                            style={{ maxWidth: "220px", whiteSpace: "nowrap" }}
                            onClick={handleCertificateDownload}
                          >
                            Download Certificate
                          </button>
                        )}
                      </div>
                    ) : eligibleForApply ? (
                      // 📝 Apply
                      <button
                        type="button"
                        className="btn btn-primary btn-sm w-100 w-sm-auto"
                        style={{ maxWidth: "200px" }}
                        onClick={openModal}
                      >
                        Apply for Condonation
                      </button>
                    ) : null}
                  </div>
                )}
              </div>
            ) : (
              <div className="card-body text-center py-5">
                <h6 className="text-muted">
                  <i className="fa-solid fa-window-restore me-2"></i>
                  Application window is not open
                </h6>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Condonation Application Modal */}
      {showModal && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1050,
            padding: "1rem",
            boxSizing: "border-box",
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: "100%", // mobile full width
              maxWidth: "620px", // desktop max width
              margin: "auto", // center vertically and horizontally
              height: "95vh",
              maxHeight: "95vh",
              /* or 1rem */
            }}
          >
            <div
              className="modal-content"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                width: "100%", // always 100% of modal-dialog
              }}
            >
              {/* Header */}
              <div
                className="modal-header"
                style={{ position: "sticky", top: 0, zIndex: 1 }}
              >
                <h5 className="modal-title">Condonation Application</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  minHeight: 0,
                }}
              >
                {/* Reason for Condonation */}
                <div className="mb-3 border rounded p-2 p-md-3">
                  <h6 className="form-label fw-semibold fs-6">
                    Reason for Absence
                  </h6>
                  <Select
                    options={reasonOptionsFormatted}
                    value={
                      selectedReason
                        ? {
                            value: selectedReason,
                            label:
                              reasonOptions.find((r) => r.id === selectedReason)
                                ?.label || "",
                          }
                        : null
                    }
                    onChange={(selected) => {
                      setSelectedReason(selected?.value || "");
                      handleFormChange(); // Add this
                    }}
                    placeholder="-- Select Reason --"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        fontSize: "0.85rem",
                      }),
                      menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    }}
                  />

                  {selectedReason === 2 && (
                    <textarea
                      className="form-control mt-3"
                      rows={3}
                      placeholder="Specify reason"
                      value={otherReasonText}
                      onChange={(e) => {
                        setOtherReasonText(e.target.value);
                        handleFormChange(); // Add this
                      }}
                      style={{ fontSize: "0.85rem", width: "100%" }}
                    />
                  )}
                </div>

                {/* Add Document Section */}
                <div className="mb-3 mb-md-4 border rounded p-2 p-md-3">
                  <h6 className="fw-bold mb-3 fs-6">Add Document</h6>

                  {/* Document Type Dropdown */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold small">
                      Document Type
                    </label>
                    <Select
                      options={documentTypeOptionsFormatted}
                      value={
                        selectedDocumentType
                          ? {
                              value: selectedDocumentType,
                              label: selectedDocumentType,
                            }
                          : null
                      }
                      onChange={(selected) =>
                        setSelectedDocumentType(selected?.value || "")
                      }
                      placeholder="-- Select Document Type --"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          fontSize: "0.85rem",
                        }),
                        menu: (provided) => ({ ...provided, zIndex: 9999 }),
                      }}
                    />
                  </div>

                  {/* File Input */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold small">
                      Choose PDF File
                    </label>
                    <input
                      type="file"
                      ref={fileInputRef}
                      className="form-control"
                      style={{ fontSize: "0.85rem" }}
                      accept=".pdf,.PDF"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file && !file.name.toLowerCase().endsWith(".pdf")) {
                          toast.error("Only PDF files are allowed!");
                          e.target.value = "";
                          setTempFiles([]);
                        } else if (file) {
                          setTempFiles([file]);
                          toast.success("File selected!");
                        } else {
                          setTempFiles([]);
                        }
                      }}
                    />
                  </div>

                  {/* Add Document Button */}
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm w-100 w-sm-auto"
                    onClick={() => {
                      if (!selectedReason)
                        return toast.error("Select a reason!");
                      if (
                        selectedReason === "Others" &&
                        !otherReasonText.trim()
                      )
                        return toast.error("Please specify the reason!");
                      if (!selectedDocumentType)
                        return toast.error("Select document type!");
                      if (!tempFiles.length)
                        return toast.error("Select at least one file!");

                      // ✅ Validate file size before adding to array
                      const maxSizeKB = 2048; // 2 MB
                      const maxSizeBytes = maxSizeKB * 1024;

                      for (const file of tempFiles) {
                        if (file.size > maxSizeBytes) {
                          toast.error(
                            `File exceeds the maximum size of 2 MB. Please upload a smaller file.`
                          );
                          return;
                        }
                      }

                      setDocumentTypes((prevDocs) => {
                        const existingDoc = prevDocs.find(
                          (doc) => doc.type === selectedDocumentType
                        );

                        if (existingDoc) {
                          return prevDocs.map((doc) =>
                            doc.type === selectedDocumentType
                              ? { ...doc, files: [...doc.files, ...tempFiles] }
                              : doc
                          );
                        } else {
                          // ✅ Always get the correct ID from defaultDocumentTypes
                          const matchedDefault = defaultDocumentTypes.find(
                            (d) => d.type === selectedDocumentType
                          );

                          const newDoc = {
                            id: matchedDefault
                              ? matchedDefault.id
                              : prevDocs.length + 1, // fallback incremental ID
                            reason:
                              selectedReason === "Others"
                                ? otherReasonText
                                : selectedReason,
                            type: selectedDocumentType,
                            files: tempFiles,
                          };

                          return [...prevDocs, newDoc];
                        }
                      });
                      handleFormChange(); // Add this at the end

                      setSelectedDocumentType("");
                      setTempFiles([]);

                      if (fileInputRef.current) {
                        fileInputRef.current.value = "";
                      }
                    }}
                  >
                    <i className="fa fa-plus me-1"></i> Add Document
                  </button>
                </div>

                {/* Display Added Documents */}
                {Array.isArray(documentTypes) &&
                  documentTypes.map((doc) => (
                    <div
                      key={doc.id}
                      className="border rounded p-2 p-md-3 mb-3"
                    >
                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="d-flex align-items-center flex-grow-1">
                          <i className="fa-solid fa-paperclip me-2"></i>
                          <small className="fw-semibold text-truncate">
                            {doc.type}
                          </small>
                        </div>

                        {/* Only show remove icon if there are no existing files */}
                        {!doc.existingFiles ||
                        doc.existingFiles.length === 0 ? (
                          <i
                            className="fa-solid fa-square-minus text-danger ms-2"
                            style={{ cursor: "pointer", fontSize: "16px" }}
                            onClick={() => {
                              setDocumentTypes(
                                documentTypes.filter((d) => d.id !== doc.id)
                              );
                            }}
                            title="Remove Document Type"
                          />
                        ) : null}
                      </div>

                      {/* Previously Uploaded Files */}
                      {doc.existingFiles && doc.existingFiles.length > 0 && (
                        <div className="mb-2">
                          <small className="text-muted fw-semibold d-block mb-2">
                            <i className="fa fa-check-circle text-success me-1"></i>
                            Previously Uploaded:
                          </small>
                          <div className="d-flex flex-column gap-2">
                            {doc.existingFiles.map((file) => (
                              <div
                                key={`existing-${file.doc_id}`}
                                className="d-flex flex-wrap align-items-center justify-content-between border rounded p-2 gap-2"
                                style={{ backgroundColor: "#e0f2fe" }}
                              >
                                <div
                                  className="d-flex align-items-center flex-grow-1 min-w-0"
                                  style={{ flexBasis: "0", overflow: "hidden" }}
                                >
                                  <i
                                    className="fa fa-file-pdf text-danger me-2"
                                    style={{ fontSize: "14px", flexShrink: 0 }}
                                  ></i>
                                  <span
                                    className="text-truncate"
                                    style={{
                                      fontSize: "12px",
                                      color: "#0369a1",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "block",
                                      minWidth: 0,
                                    }}
                                    title={file.name}
                                  >
                                    {file.name}
                                  </span>
                                </div>
                                <div className="d-flex gap-2">
                                  <i
                                    className="fa fa-eye text-primary"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                    onClick={async () => {
                                      if (window.innerWidth <= 768) {
                                        // Mobile: Fetch PDF securely via GET and open
                                        try {
                                          let fileURL = "";

                                          // Priority 1: Check for temporary blob URL (newly saved files)
                                          if (
                                            file.tempBlobURL &&
                                            file.tempBlobURL.startsWith("blob:")
                                          ) {
                                            fileURL = file.tempBlobURL;
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }

                                          // Priority 2: Check if doc_id is in fileBlobMap (temp files)
                                          if (
                                            file.doc_id &&
                                            fileBlobMap.has(file.doc_id)
                                          ) {
                                            fileURL = fileBlobMap.get(
                                              file.doc_id
                                            );
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }

                                          // Priority 3: Use GET API with doc_id for existing files in DB (non-temp)
                                          if (
                                            file.doc_id &&
                                            !String(file.doc_id).startsWith(
                                              "temp_"
                                            )
                                          ) {
                                            const { http } = Api();

                                            const response = await http.get(
                                              `/Student/viewCondonationPDF?doc_id=${file.doc_id}`,
                                              {
                                                responseType: "blob",
                                                headers: {
                                                  Accept: "application/pdf",
                                                },
                                              }
                                            );

                                            if (
                                              response.data &&
                                              response.data.type ===
                                                "application/pdf"
                                            ) {
                                              const blob = new Blob(
                                                [response.data],
                                                { type: "application/pdf" }
                                              );
                                              fileURL =
                                                URL.createObjectURL(blob);

                                              window.open(
                                                fileURL,
                                                "_blank",
                                                "noopener,noreferrer"
                                              );

                                              setTimeout(
                                                () =>
                                                  URL.revokeObjectURL(fileURL),
                                                10000
                                              );
                                              return;
                                            } else {
                                              throw new Error(
                                                "Invalid PDF response"
                                              );
                                            }
                                          }
                                          // Priority 4: Newly uploaded files (before saving) - no doc_id yet
                                          else if (file instanceof File) {
                                            fileURL = URL.createObjectURL(file);
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }
                                          // Priority 5: Existing blob URLs (temp files)
                                          else if (
                                            file.url &&
                                            file.url.startsWith("blob:")
                                          ) {
                                            fileURL = file.url;
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }
                                          // Priority 6: Fallback to URL method (less secure but works)
                                          else if (file.url) {
                                            fileURL = file.url;
                                            if (!fileURL.startsWith("http")) {
                                              const { http } = Api();
                                              const apiBaseUrl =
                                                http.defaults.baseURL ||
                                                window.location.origin;
                                              const domainUrl = apiBaseUrl
                                                .replace("/api/", "/")
                                                .replace(/\/$/, "");
                                              fileURL = `${domainUrl}${
                                                fileURL.startsWith("/")
                                                  ? fileURL
                                                  : "/" + fileURL
                                              }`;
                                            }
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          } else {
                                            // If no URL or doc_id available, fallback to modal
                                            handlePreview(file);
                                            return;
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Mobile preview error:",
                                            error
                                          );

                                          // Fallback: Try opening modal instead
                                          try {
                                            handlePreview(file);
                                          } catch (modalError) {
                                            toast.error(
                                              "Unable to preview this file"
                                            );
                                          }
                                        }
                                      } else {
                                        // Desktop: open modal as usual
                                        handlePreview(file);
                                      }
                                    }}
                                    title="Preview PDF"
                                  ></i>

                                  <i
                                    className="fa-solid fa-square-minus text-danger"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "15px",
                                    }}
                                    onClick={() =>
                                      removeExistingFile(doc.id, file.doc_id)
                                    }
                                    title="Remove Document"
                                  ></i>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Newly Added Files */}
                      {doc.files && doc.files.length > 0 && (
                        <div>
                          {doc.existingFiles &&
                            doc.existingFiles.length > 0 && (
                              <small className="text-muted fw-semibold d-block mb-2">
                                <i className="fa fa-plus-circle text-primary me-1"></i>
                                Newly Added:
                              </small>
                            )}
                          <div className="d-flex flex-column gap-2">
                            {doc.files.map((file, idx) => (
                              <div
                                key={`new-${idx}`}
                                className="d-flex align-items-center justify-content-between border rounded p-2"
                                style={{
                                  backgroundColor: "#fef3c7",
                                  overflow: "hidden",
                                }}
                              >
                                <div
                                  className="d-flex align-items-center flex-grow-1 me-2"
                                  style={{ minWidth: 0 }} // 🧩 allows truncation
                                >
                                  {/* filename text */}
                                  <span
                                    className="text-truncate"
                                    title={file.name} // 🧠 tooltip with full name
                                    style={{
                                      fontSize: "12px",
                                      color: "#92400e",
                                      maxWidth: "180px", // adjust based on layout width
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "inline-block",
                                    }}
                                  >
                                    {file.name}
                                  </span>
                                </div>

                                <div className="d-flex gap-2 flex-shrink-0">
                                  <i
                                    className="fa fa-eye text-primary"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => {
                                      // First try the mobile-specific handling for new files
                                      const handledByMobile =
                                        handleNewFilePreview(file);
                                      // If not handled by mobile logic, use the original handler
                                      if (!handledByMobile) {
                                        handlePreview(file);
                                      }
                                    }}
                                    title="Preview PDF"
                                  ></i>
                                  <i
                                    className="fa fa-times text-danger"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "14px",
                                    }}
                                    onClick={() => removeNewFile(doc.id, idx)}
                                    title="Remove file"
                                  ></i>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}

                {/* Remarks Section */}
                <div className="border rounded p-2 p-md-3 mb-3 mb-md-4">
                  <h6 className="form-label fw-semibold fs-6">
                    Remarks (Optional)
                  </h6>
                  <textarea
                    className="form-control mt-2"
                    rows={3}
                    placeholder="Enter any remarks for your condonation request"
                    value={remarkText}
                    onChange={(e) => {
                      setRemarkText(e.target.value);
                      handleFormChange(); // Add this
                    }}
                    style={{ fontSize: "0.85rem" }}
                  />
                </div>

                {/* Payment Section */}
                {/* Application Fee Card */}
                <div className="border rounded p-2 p-md-3 mb-3 mb-md-4">
                  {/* Card Header */}
                  <h6 className="fw-semibold mb-3 text-dark">
                    Fee for Condonation
                  </h6>

                  {/* Fee Breakdown */}
                  <div className="mb-3">
                    <div className="d-flex justify-content-between mb-1">
                      <span>Application Fee</span>
                      <span>
                        {applicationFee !== null
                          ? `₹${applicationFee}`
                          : "Loading..."}
                      </span>
                    </div>
                    <hr />
                    <div className="d-flex justify-content-between fw-bold fs-6">
                      <span>Total</span>
                      <span>
                        {applicationFee !== null
                          ? `₹${applicationFee}` // sum of fee + taxes + other charges
                          : "Loading..."}
                      </span>
                    </div>
                  </div>

                  {/* Payment Button */}
                  <button
                    type="button"
                    className="btn btn-primary w-100 w-sm-auto"
                    onClick={
                      canProceedToPayment
                        ? handleProceedToPayment
                        : handleSaveDetails
                    }
                    disabled={isUploading || documentTypes.length === 0}
                  >
                    {isUploading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        <span className="d-none d-sm-inline">
                          {canProceedToPayment
                            ? "Processing Payment..."
                            : "Uploading & Saving Details..."}
                        </span>
                        <span className="d-inline d-sm-none">
                          {canProceedToPayment ? "Paying..." : "Saving..."}
                        </span>
                      </>
                    ) : canProceedToPayment ? (
                      "Proceed to Payment"
                    ) : (
                      "Save Details"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Application Modal */}
      {showViewModal && applicationDetails && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1050,
            padding: "1rem",
            boxSizing: "border-box",
          }}
        >
          <div
            className="modal-dialog"
            style={{
              width: "100%",
              maxWidth: "900px",
              margin: "auto",
              height: "90vh",
              maxHeight: "125vh",
            }}
          >
            <div
              className="modal-content"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                width: "100%",
              }}
            >
              {/* Header */}
              <div
                className="modal-header responsive-modal-header"
                style={{ position: "sticky", top: 0, zIndex: 1 }}
              >
                <h5 className="modal-title">
                  <i className="fa fa-file-text me-2"></i>
                  Condonation Application Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeViewModal}
                ></button>
              </div>

              <style jsx>{`
                .responsive-modal-header .modal-title {
                  font-size: 1.25rem; /* default desktop size */
                }

                @media (max-width: 768px) {
                  .responsive-modal-header .modal-title {
                    font-size: 1rem; /* smaller on mobile */
                  }
                }
              `}</style>

              {/* Body */}
              <div
                className="modal-body"
                style={{
                  flex: 1,
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  minHeight: 0,
                }}
              >
                {/* Application Status */}
                <div className="mb-3 border rounded p-3 bg-light">
                  <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                    <h6
                      className="mb-0 fw-semibold text-dark"
                      style={{ minWidth: 0 }}
                    >
                      <i className="fa fa-info-circle me-2 text-primary"></i>
                      Application Status
                    </h6>
                    <span
                      className="badge bg-success flex-shrink-0"
                      style={{
                        fontSize: "0.95rem", // default size
                      }}
                    >
                      <i className="fa fa-check-circle me-1"></i>
                      Application Submitted
                    </span>
                  </div>
                  <div className="text-muted d-block">
                    <i className="fa fa-calendar me-1"></i>
                    Semester {activecoTab} • {courses.length} Course(s) Applied
                  </div>

                  <style jsx>{`
                    @media (max-width: 576px) {
                      .badge.bg-success {
                        font-size: 0.75rem !important;
                      }
                    }
                  `}</style>
                </div>

                {/* Student Information */}
                {courses.length > 0 && (
                  <div className="mb-3 border rounded p-3">
                    <h6 className="fw-semibold mb-3">
                      <i className="fa fa-user me-2 text-primary"></i>
                      Student Information
                    </h6>
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <strong>Name:</strong> {courses[0].studentname}
                      </div>
                      <div className="col-md-6 mb-2">
                        <strong>PRN:</strong> {courses[0].prn}
                      </div>
                      <div className="col-md-6 mb-2">
                        <strong>Admission Year:</strong>{" "}
                        {courses[0].admissionyear}
                      </div>
                      <div className="col-md-6 mb-2">
                        <strong>Current Semester:</strong>{" "}
                        {courses[0].currentsemester}
                      </div>
                    </div>
                  </div>
                )}

                {/* Applied Courses */}
                <div className="mb-3 border rounded p-3">
                  <h6 className="fw-semibold mb-3">
                    <i className="fa fa-book me-2 text-primary"></i>
                    Applied Courses
                  </h6>
                  <div className="row">
                    {courses.map((course, index) => (
                      <div key={course.course_id} className="col-md-6 mb-2">
                        <div className="border rounded p-2 bg-light d-flex flex-column">
                          {/* Top row: index and condonation */}
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <span className="badge bg-primary rounded-pill small">
                              #{index + 1}
                            </span>

                            {course.condonation_time && (
                              <span
                                className="badge bg-warning text-dark small text-truncate"
                                style={{ maxWidth: "50%" }}
                                title={course.condonation_time}
                              >
                                {course.condonation_time}
                              </span>
                            )}
                          </div>

                          {/* Course Code */}
                          <div className="fw-semibold small text-secondary">
                            {course.course_code}
                          </div>

                          {/* Course Name */}
                          <div
                            className="text-muted"
                            style={{ fontSize: "0.75rem" }}
                          >
                            {course.course_name}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Reason for Condonation */}
                {applicationDetails.reasonRemarks.length > 0 && (
                  <div className="mb-3 border rounded p-3 text-dark">
                    <h6 className="fw-semibold mb-3">
                      <i className="fa fa-question-circle me-2 text-primary"></i>
                      Reason for Absence
                    </h6>

                    {applicationDetails.reasonRemarks.map((reason, index) => (
                      <div
                        key={reason.id || index}
                        className="mb-3 border rounded p-3"
                      >
                        {/* Reason row */}
                        <div className="col-12 mb-2 pb-2 border-bottom">
                          <div className="row g-0 align-items-start">
                            <div className="col-auto" style={{ minWidth: 140 }}>
                              <strong>
                                <i className="fa-solid fa-tag me-1 "></i>
                                Reason:
                              </strong>
                            </div>
                            <div className="col">
                              {Number(reason.student_reason) === 2 &&
                              reason.other_reason
                                ? reason.other_reason
                                : reason.reason}
                            </div>
                          </div>
                        </div>

                        {/* Remarks row (only if present) */}
                        {reason.student_remarks && (
                          <div className="col-12 mb-2">
                            <div className="row g-0 align-items-start">
                              <div
                                className="col-auto pe-3"
                                style={{ minWidth: 140 }}
                              >
                                <strong>
                                  <i class="fa-solid fa-comment me-0.5"></i>{" "}
                                  Remarks:
                                </strong>
                              </div>
                              <div className="col">
                                {reason.student_remarks}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {/* Uploaded Documents */}
                {applicationDetails.documents &&
                  applicationDetails.documents.length > 0 && (
                    <div className="mb-3 border rounded p-3">
                      <h6 className="fw-semibold mb-3">
                        <i className="fa fa-file-pdf me-2 text-primary"></i>
                        Uploaded Documents (
                        {applicationDetails.documents.length})
                      </h6>
                      <div className="row">
                        {applicationDetails.documents.map((doc, index) => (
                          <div key={doc.id} className="col-12 mb-2">
                            <div className="border rounded p-2 bg-light">
                              <div className="d-flex flex-wrap justify-content-between align-items-start">
                                <div className="flex-grow-1 me-2">
                                  <div className="d-flex align-items-center mb-1 flex-wrap">
                                    <i className="fa fa-file-pdf text-danger me-2"></i>
                                    <span className="fw-semibold small text-dark">
                                      {doc.docu_name}
                                    </span>
                                    <span className="badge bg-primary ms-2 small">
                                      #{index + 1}
                                    </span>
                                  </div>
                                  <div
                                    className="text-muted small text-truncate"
                                    title={doc.name}
                                  >
                                    <i className="fa fa-paperclip me-1"></i>
                                    {doc.name}
                                  </div>
                                </div>
                                <div className="d-flex gap-2 mt-2 mt-sm-0">
                                  <button
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={async () => {
                                      if (window.innerWidth <= 768) {
                                        // Mobile: Fetch PDF securely and open directly
                                        try {
                                          let fileURL = "";

                                          // Priority 1: Check for temporary blob URL (newly saved files)
                                          if (
                                            doc.tempBlobURL &&
                                            doc.tempBlobURL.startsWith("blob:")
                                          ) {
                                            fileURL = doc.tempBlobURL;
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }

                                          // Priority 2: Check if doc_id is in fileBlobMap (temp files)
                                          if (
                                            doc.doc_id &&
                                            fileBlobMap.has(doc.doc_id)
                                          ) {
                                            fileURL = fileBlobMap.get(
                                              doc.doc_id
                                            );
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }

                                          // Priority 3: Use GET API with doc_id for existing files in DB (non-temp)
                                          if (
                                            doc.doc_id &&
                                            !String(doc.doc_id).startsWith(
                                              "temp_"
                                            )
                                          ) {
                                            const { http } = Api();

                                            const response = await http.get(
                                              `/Student/viewCondonationPDF?doc_id=${doc.doc_id}`,
                                              {
                                                responseType: "blob",
                                                headers: {
                                                  Accept: "application/pdf",
                                                },
                                              }
                                            );

                                            if (
                                              response.data &&
                                              response.data.type ===
                                                "application/pdf"
                                            ) {
                                              const blob = new Blob(
                                                [response.data],
                                                { type: "application/pdf" }
                                              );
                                              fileURL =
                                                URL.createObjectURL(blob);

                                              window.open(
                                                fileURL,
                                                "_blank",
                                                "noopener,noreferrer"
                                              );

                                              setTimeout(
                                                () =>
                                                  URL.revokeObjectURL(fileURL),
                                                10000
                                              );
                                              return;
                                            } else {
                                              throw new Error(
                                                "Invalid PDF response"
                                              );
                                            }
                                          }
                                          // Priority 4: Newly uploaded File object
                                          else if (doc instanceof File) {
                                            fileURL = URL.createObjectURL(doc);
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }
                                          // Priority 5: Existing blob URL (temp files)
                                          else if (
                                            doc.url &&
                                            doc.url.startsWith("blob:")
                                          ) {
                                            fileURL = doc.url;
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          }
                                          // Priority 6: Fallback to URL method (less secure but works)
                                          else if (doc.url) {
                                            fileURL = doc.url;

                                            if (!fileURL.startsWith("http")) {
                                              const { http } = Api();
                                              const apiBaseUrl =
                                                http.defaults.baseURL ||
                                                window.location.origin;
                                              const domainUrl = apiBaseUrl
                                                .replace("/api/", "/")
                                                .replace(/\/$/, "");
                                              fileURL = `${domainUrl}${
                                                fileURL.startsWith("/")
                                                  ? fileURL
                                                  : "/" + fileURL
                                              }`;
                                            }
                                            window.open(
                                              fileURL,
                                              "_blank",
                                              "noopener,noreferrer"
                                            );
                                            return;
                                          } else {
                                            // Fallback: use the original handlePreview
                                            handlePreview({
                                              name: doc.name,
                                              url: doc.url,
                                              doc_id: doc.doc_id,
                                              tempBlobURL: doc.tempBlobURL,
                                            });
                                            return;
                                          }
                                        } catch (error) {
                                          console.error(
                                            "Mobile preview error:",
                                            error
                                          );

                                          // Fallback: Try opening modal instead
                                          try {
                                            handlePreview({
                                              name: doc.name,
                                              url: doc.url,
                                              doc_id: doc.doc_id,
                                              tempBlobURL: doc.tempBlobURL,
                                            });
                                          } catch (modalError) {
                                            toast.error(
                                              "Unable to preview this file"
                                            );
                                          }
                                        }
                                      } else {
                                        // Desktop: use existing modal logic
                                        handlePreview({
                                          name: doc.name,
                                          url: doc.url,
                                          doc_id: doc.doc_id,
                                          tempBlobURL: doc.tempBlobURL,
                                        });
                                      }
                                    }}
                                    title="Preview Document"
                                  >
                                    <i className="fa fa-eye"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                {/* Application Summary */}
                <div className="border rounded p-3 bg-opacity-10">
                  <h6 className="fw-semibold mb-3 text-dark">
                    <i className="fa fa-clipboard-check me-2 text-primary"></i>
                    Application Summary
                  </h6>

                  {/* Total Courses */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <span className="text-muted">Total Courses</span>
                    </div>
                    <div className="fw-bold">{courses.length}</div>
                  </div>

                  {/* Documents Uploaded */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <span className="text-muted">Documents Uploaded</span>
                    </div>
                    <div className="fw-bold">
                      {applicationDetails.documents
                        ? applicationDetails.documents.length
                        : 0}
                    </div>
                  </div>

                  {/* Application Fee */}
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                      <span className="text-muted">Application Fee </span>
                    </div>
                    <div className="fw-bold">
                      {paidAmount > 0 ? `₹${paidAmount}` : "Not Paid"}
                    </div>
                  </div>

                  <hr className="my-3" />
                  <div className="text-center">
                    <small className="text-muted">
                      <i className="fa fa-info-circle me-1"></i>
                      Your application has been successfully submitted and
                      payment completed.
                    </small>
                  </div>
                </div>
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={generateCondonationPdf}
                  disabled={loading} // disable while loading
                >
                  <i className="fa fa-print me-1"></i>
                  {loading ? "Generating..." : "Print Details"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PDF Preview Modal */}
      {previewFile && (
        <div
          className="modal fade show d-flex align-items-center justify-content-center p-1 p-md-4"
          style={{
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1060,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down"
            style={{
              height: "95vh",
              maxHeight: "95vh",
              maxWidth: "1200px",
              margin: "auto",
            }}
          >
            <div
              className="modal-content"
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {/* Header */}
              <div
                className="modal-header p-2 p-md-3"
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 1,
                  backgroundColor: "#fff",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title fs-6 fs-md-5 text-truncate me-2">
                  <i className="fa fa-file-pdf text-danger me-2"></i>
                  <span className="d-none d-md-inline">PDF Preview: </span>
                  {previewFile.name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closePreview}
                ></button>
              </div>

              {/* Body */}
              <div
                className="modal-body p-0"
                style={{
                  flex: "1 1 auto",
                  overflow: "hidden",
                  minHeight: 0,
                }}
              >
                {previewFile.url ? (
                  <>
                    {window.innerWidth > 768 ? (
                      <iframe
                        src={`${previewFile.url}#toolbar=0&navpanes=0&scrollbar=1&zoom=page-fit`}
                        style={{
                          width: "100%",
                          height: "100%",
                          border: "none",
                        }}
                        title="PDF Preview"
                        onError={(e) => {
                          toast.error(
                            "Unable to preview PDF. Please try downloading."
                          );
                        }}
                      />
                    ) : (
                      <div className="h-100 d-flex flex-column">
                        <iframe
                          src={previewFile.url}
                          style={{ width: "100%", flex: "1", border: "none" }}
                          title="PDF Preview"
                          onError={(e) => {
                            toast.error(
                              "Unable to preview PDF. Please try downloading."
                            );
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="p-4 text-center">
                    <i className="fa fa-file-pdf fa-3x text-danger mb-3"></i>
                    <p className="mb-3">Unable to load PDF preview.</p>
                    <button
                      className="btn btn-primary"
                      onClick={() => window.open(previewFile.url, "_blank")}
                    >
                      <i className="fa fa-external-link me-1"></i>
                      Try Opening in New Tab
                    </button>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div
                className="modal-footer p-2 p-md-3 d-flex justify-content-end"
                style={{
                  position: "sticky",
                  bottom: 0,
                  zIndex: 1,
                  backgroundColor: "#fff",
                  borderTop: "1px solid #dee2e6",
                }}
              ></div>
            </div>
          </div>
        </div>
      )}
    </StudentTemplate>
  );
}
